<template>
    <div class="bg-base-200 h-screen-header rounded-xl w-full xl:w-screen-sidebar">
        <div class="flex">
            <!-- 歌词 -->
            <div ref="lyric-section" class="lyric-section flex flex-col !hidden md:!block" v-if="showControl && tracks.length > 0">
                <div class="mt-2 ml-2 text-md">播放：</div>
                <div class="bg-base-100 rounded-xl mr-2 flex flex-col">
                    <div v-for="(item, index) in tracks.slice(queueIndex, queueIndex + 1)" :key="'q' + index"
                        class="flex justify-between items-center">
                        <div class="flex items-center mt-1">
                            <router-link :to="{ name: 'playingList', params: { id: item.id } }"
                                class="mx-2 h-16 w-16 my-1 hover:brightness-50">
                                <img v-if="item.image" :src="item.image" class="rounded-md"
                                    style="width: 56px; height: 56px; object-fit: cover;">
                                <img v-else src="/static/dist/img/album_null.jpg"
                                    style="width: 56px; height: 56px; object-fit: cover;">
                            </router-link>
                            <div class="min-w-0 flex-1">
                                <router-link :to="{ name: 'album', params: { id: item.albumId } }"
                                    class="hover:underline">
                                    <div class="truncate">
                                        {{ item.title }}
                                    </div>
                                </router-link>
                                <router-link :to="{ name: 'artist', params: { id: item.artistId } }"
                                    class="hover:underline">
                                    <div class="w-64 truncate text-gray-400 text-xs">
                                        {{ item.artist || item.album }}
                                    </div>
                                </router-link>
                            </div>
                        </div>
                        <div>
                            <div class="flex items-center justify-center">
                                <button variant="link" class="m-2" @click="next">
                                    <svg t="1697292423300" class="icon fill-current hover:fill-gray-600"
                                        viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
                                        p-id="2433" width="32" height="32">
                                        <path
                                            d="M213.333333 331.349333c0-66.304 72.362667-107.306667 129.237334-73.173333l301.056 180.650667c55.253333 33.152 55.253333 113.194667 0 146.346666L342.613333 765.824c-56.874667 34.133333-129.237333-6.826667-129.237333-73.173333V331.349333zM599.722667 512L298.666667 331.349333v361.301334L599.722667 512zM768 256a42.666667 42.666667 0 0 1 42.666667 42.666667v426.666666a42.666667 42.666667 0 1 1-85.333334 0V298.666667a42.666667 42.666667 0 0 1 42.666667-42.666667z"
                                            p-id="2434"></path>
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex items-center justify-center mt-4 rounded-xl flex-1 flex-col">
                    <div class="relative overflow-hidden w-full h-full rounded-xl mr-2">
                        <!-- 背景图片和模糊效果 -->
                        <!--                        <div class="absolute inset-0 bg-cover bg-center blur-sm rounded-xl opacity-5" :style="{ 'background-image': 'linear-gradient(to bottom, transparent, black),' + backgroundImage }"></div>-->

                        <!-- 歌词容器 -->
                        <div class="p-4 text-white">
                            <div class="overflow-y-auto h-screen-lyric">
                                <div>
                                    <ul ref="lyricUL">
                                        <li v-for="(item, i) in lyricsObjArr"
                                            :class="[lyricIndex === i ? 'text-2xl text-primary' : 'text-base text-gray-400', 'text-center', 'mb-2', 'cursor-pointer']"
                                            :key="item.uid" :data-index="i" ref="lyric" @click="scrollToLyric(i)">
                                            <div>{{ item.lyric }}</div>
                                        </li>
                                    </ul>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 拖拽手柄 -->
            <div class="resize-handle" 
                 :class="{ resizing: isResizing }" 
                 @mousedown="startLyricResize"
                 v-if="showControl && tracks.length > 0"></div>
            <!-- 正在播放 -->
            <div class="bg-base-100 rounded-3xl shadow-xl p-3 h-screen-header flex-1 overflow-x-auto">
                <!-- 按钮组 -->
                <div class="flex flex-col">
                    <h1 class="mt-2 ml-2 text-2xl flex items-center">
                        <svg t="1734154913013" v-if="showControl"
                            class="icon h-5 w-5 fill-neutral-content cursor-pointer" @click="showControl = !showControl"
                            viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1622"
                            width="200" height="200">
                            <path
                                d="M782 99m41.5 0l0 0q41.5 0 41.5 41.5l0 747q0 41.5-41.5 41.5l0 0q-41.5 0-41.5-41.5l0-747q0-41.5 41.5-41.5Z"
                                p-id="1623"></path>
                            <path
                                d="M603.5 858.83L244.89 514 603.5 169.17a40.31 40.31 0 0 0 12.5-29c0-36.58-46-54.9-72.88-29L184.51 455.94c-33.35 32.07-33.35 84.05 0 116.12l358.61 344.83c26.89 25.87 72.88 7.55 72.88-29a40.31 40.31 0 0 0-12.5-29.06z">
                            </path>
                        </svg>
                        <svg t="1734155012178" v-else class="icon h-5 w-5 fill-neutral-content cursor-pointer"
                            viewBox="0 0 1024 1024" @click="showControl = !showControl" version="1.1"
                            xmlns="http://www.w3.org/2000/svg" p-id="1775" width="200" height="200">
                            <path
                                d="M245.71 927m-41.47 0l0 0q-41.47 0-41.47-41.47l0-747.06q0-41.47 41.47-41.47l0 0q41.47 0 41.47 41.47l0 747.06q0 41.47-41.47 41.47Z"
                                p-id="1776"></path>
                            <path
                                d="M424.09 856.83L782.44 512 424.09 167.17a40.31 40.31 0 0 1-12.5-29c0-36.58 46-54.9 72.83-29l358.36 344.77c33.32 32.07 33.32 84.05 0 116.12L484.42 914.89c-26.87 25.87-72.83 7.55-72.83-29a40.31 40.31 0 0 1 12.5-29.06z">
                            </path>
                        </svg>
                        <div class="ml-2 flex items-center">
                            <span>音乐播放</span>
                            <!-- DLNA状态指示器 -->
                            <div v-if="isDlnaMode" class="ml-2 flex items-center">
                                <div class="badge badge-primary badge-sm text-white">DLNA</div>
                            </div>
                        </div>
                    </h1>
                    <div class="mt-2 ml-2 flex items-center justify-between">
                        <div class="flex items-center">
                            <button class="btn btn-sm mr-2 tooltip" @click="shuffle" data-tip="打乱顺序">
                                <svg t="1734160766139" class="fill-current icon h-4 w-4" viewBox="0 0 1024 1024"
                                    version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1470" width="200"
                                    height="200">
                                    <path
                                        d="M753.564731 337.471035c-45.8697 0-160.259984 113.849978-243.789399 194.548928C383.134027 654.383848 263.508509 773.284865 167.764911 773.284865l-58.892295 0c-24.068162 0-43.581588-19.526729-43.581588-43.581588s19.513426-43.581588 43.581588-43.581588l58.892295 0c60.504002 0 183.002964-121.68134 281.432741-216.784348 119.79641-115.744117 223.254713-219.029482 304.368102-219.029482l56.209186 0-59.641355-57.828057c-17.033955-16.993023-17.060561-42.902112-0.057305-59.927881 17.002232-17.030885 44.596707-17.064654 61.631686-0.065492l134.207631 133.874033c8.192589 8.172123 12.794397 19.238157 12.794397 30.803563 0 11.564383-4.601808 22.604834-12.794397 30.776957L811.706943 461.72599c-8.505721 8.486278-19.646456 12.522198-30.78719 12.522198-11.166317 0-22.333658-4.676509-30.844495-13.199627-17.003256-17.025769-16.975627-45.432749 0.057305-62.425771l59.641355-61.151755L753.564731 337.471035zM811.706943 561.66105c-17.034978-16.999163-44.629453-16.972557-61.631686 0.058328-17.003256 17.024745-16.975627 46.257533 0.057305 63.250556l59.641355 61.150732-56.209186 0c-35.793204 0-95.590102-52.946886-154.87637-108.373243-17.576307-16.435321-45.161572-16.3422-61.594847 1.226944-16.444531 17.568121-15.523555 46.393633 2.053776 62.823837 90.322122 84.458577 151.246703 131.484613 214.417441 131.484613l56.209186 0-59.641355 57.824987c-17.033955 16.993023-17.060561 43.736107-0.057305 60.761875 8.511861 8.523117 19.678178 12.369725 30.844495 12.369725 11.140735 0 22.281469-4.453429 30.78719-12.939707L945.914574 757.311055c8.192589-8.173147 12.794397-19.315928 12.794397-30.881334 0-11.564383-4.601808-22.682605-12.794397-30.855752L811.706943 561.66105zM108.871593 337.471035l58.892295 0c45.932122 0 114.40154 58.455343 168.915108 107.942431 8.352225 7.576559 18.832927 12.140505 29.29214 12.140505 11.852956 0 23.673166-4.394077 32.270984-13.857613 16.182564-17.807574 14.859429-46.823422-2.958378-62.998823-85.247546-77.381391-156.561755-130.388652-227.519854-130.388652l-58.892295 0c-24.068162 0-43.581588 19.526729-43.581588 43.581588S84.804455 337.471035 108.871593 337.471035z"
                                        p-id="1471"></path>
                                </svg>
                            </button>
                            <button class="btn btn-sm mr-2 tooltip" @click="playNow('random')" data-tip="随机播放">
                                <svg t="1734160963084" class="fill-current icon h-4 w-4" viewBox="0 0 1024 1024"
                                    version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7677" width="200"
                                    height="200">
                                    <path
                                        d="M512 176c158.784 0 288 123.136 288 274.56v90.24h38.4a57.6 57.6 0 0 1 57.6 57.6v192a57.6 57.6 0 0 1-57.6 57.6h-38.4a57.6 57.6 0 0 1-57.6-57.6V450.56c0-119.68-103.36-216.96-230.4-216.96S281.6 330.88 281.6 450.56v339.84a57.6 57.6 0 0 1-57.6 57.6h-38.4a57.6 57.6 0 0 1-57.6-57.6v-192a57.6 57.6 0 0 1 57.6-57.6h38.4V450.56c0-151.424 129.216-274.56 288-274.56z m-32.128 309.632a28.928 28.928 0 0 1 27.072 17.664l47.296 112.96 8.512-18.112a28.8 28.8 0 0 1 26.048-16.512h76.8a28.8 28.8 0 1 1 0 57.6h-58.496l-28.416 60.224a28.8 28.8 0 0 1-26.048 16.576h-0.64a28.8 28.8 0 0 1-25.92-17.728l-44.288-105.92-10.624 28.16a28.8 28.8 0 0 1-26.944 18.624H358.4a28.8 28.8 0 1 1 0-57.6h65.92l29.12-77.312a28.8 28.8 0 0 1 26.432-18.688z">
                                    </path>
                                </svg>
                            </button>
                            <button class="btn btn-sm tooltip" @click="clear" data-tip="清空队列">
                                <svg t="1734161038628" class="fill-current icon h-4 w-4" viewBox="0 0 1024 1024"
                                    version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8667" width="200"
                                    height="200">
                                    <path
                                        d="M228 385v488.782c0 29.34 24.03 53.218 53.784 53.218h460.432C771.97 927 796 903.123 796 873.782V385H228z m640 0v488.782C868 942.99 811.634 999 742.216 999H281.784C212.366 999 156 942.99 156 873.782V385H87c-19.882 0-36-16.118-36-36v-33.575c0-38.642 14.962-78.077 41.31-108.02C121.451 174.289 162.222 155 208.593 155h607.143c46.387 0 87.094 19.174 116.128 52.197C958.151 237.096 973 276.53 973 315.425V349c0 19.882-16.118 36-36 36h-69zM352 118.5c-19.882 0-36-16.118-36-36s16.118-36 36-36h320c19.882 0 36 16.118 36 36s-16.118 36-36 36H352z m525.791 136.238C862.17 236.97 841.003 227 815.736 227H208.593c-25.208 0-46.47 10.06-62.23 27.969-14.246 16.19-22.7 37.655-23.326 58.031h777.927c-0.612-20.673-9.003-42.145-23.173-58.262zM336.5 528c0-19.882 16.118-36 36-36s36 16.118 36 36v263c0 19.882-16.118 36-36 36s-36-16.118-36-36V528z m140 0c0-19.882 16.118-36 36-36s36 16.118 36 36v263c0 19.882-16.118 36-36 36s-36-16.118-36-36V528z m140 0c0-19.882 16.118-36 36-36s36 16.118 36 36v263c0 19.882-16.118 36-36 36s-36-16.118-36-36V528z">
                                    </path>
                                </svg>
                            </button>
                            <div class="divider divider-horizontal"></div>
                            <button variant="link" class="btn btn-sm tooltip mr-2" @click="previous" data-tip="上一首">
                                <svg t="1697292326917" class="fill-current icon h-4 w-4" viewBox="0 0 1024 1024"
                                    version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4372" width="32" height="32">
                                    <path
                                        d="M810.666667 331.349333c0-66.304-72.362667-107.306667-129.237334-73.173333l-301.056 180.650667c-55.253333 33.152-55.253333 113.194667 0 146.346666l301.056 180.650667c56.874667 34.133333 129.237333-6.826667 129.237334-73.173333V331.349333zM424.277333 512L725.333333 331.349333v361.301334L424.277333 512zM256 256a42.666667 42.666667 0 0 1 42.666667 42.666667v426.666666a42.666667 42.666667 0 1 1-85.333334 0V298.666667a42.666667 42.666667 0 0 1 42.666667-42.666667z"
                                        p-id="4373"></path>
                                </svg>
                            </button>
                            <button class="btn btn-sm tooltip mr-2" data-tip="播放" @click="playPause">
                                <svg v-if="!$store.state.common.isPlaying" class="fill-current icon h-4 w-4" viewBox="0 0 1024 1024"
                                    version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9809" width="200"
                                    height="200">
                                    <path
                                        d="M512 96C282.624 96 96 282.624 96 512s186.624 416 416 416 416-186.624 416-416S741.376 96 512 96z m0 768C317.92 864 160 706.08 160 512S317.92 160 512 160s352 157.92 352 352-157.92 352-352 352z"
                                        p-id="9810"></path>
                                    <path
                                        d="M466.816 324.96a32 32 0 0 0-50.816 25.888v339.776a32 32 0 0 0 50.816 25.856l233.6-169.888a32 32 0 0 0 0-51.776l-233.6-169.856z"
                                        p-id="9811"></path>
                                </svg>
                                <svg v-else class="fill-current icon h-4 w-4" viewBox="0 0 1024 1024" version="1.1"
                                    xmlns="http://www.w3.org/2000/svg" p-id="4492" width="32" height="32">
                                    <path
                                        d="M512 1024A512 512 0 1 1 512 0a512 512 0 0 1 0 1024zM320 320v384h128V320H320z m256 0v384h128V320H576z"
                                        p-id="4493"></path>
                                </svg>
                            </button>
                            <button variant="link" class="btn btn-sm tooltip" @click="next" data-tip="下一首">
                                <svg t="1697292423300" class="fill-current icon h-4 w-4" viewBox="0 0 1024 1024"
                                    version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2433" width="32" height="32">
                                    <path
                                        d="M213.333333 331.349333c0-66.304 72.362667-107.306667 129.237334-73.173333l301.056 180.650667c55.253333 33.152 55.253333 113.194667 0 146.346666L342.613333 765.824c-56.874667 34.133333-129.237333-6.826667-129.237333-73.173333V331.349333zM599.722667 512L298.666667 331.349333v361.301334L599.722667 512zM768 256a42.666667 42.666667 0 0 1 42.666667 42.666667v426.666666a42.666667 42.666667 0 1 1-85.333334 0V298.666667a42.666667 42.666667 0 0 1 42.666667-42.666667z"
                                        p-id="2434"></path>
                                </svg>
                            </button>
                        </div>
                        <!-- DLNA设备选择器 -->
                        <div class="flex items-center">
                            <DLNADeviceSelector @device-selected="onDeviceSelected" />
                        </div>
                    </div>
                </div>
                <!-- 播放列表 -->
                <div class="rounded-xl overflow-y-auto h-[86.3%]" v-if="tracks.length > 0">
                    <TrackImageList :tracks="tracks" no-artist :index-field="'index'" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import TrackAction from "@/views/library/track/TrackAction";
import DLNADeviceSelector from '@/components/dlna/DLNADeviceSelector'
import { mapGetters } from 'vuex'
import TrackImageList from '@/views/library/track/TrackImageList'

export default {
    components: {
        TrackAction,
        DLNADeviceSelector,
        TrackImageList
    },
    data() {
        return {
            showControl: true,
            lyricIndex: 0,
            lyricsObjArr: [],
            timer: null,
            refreshTimer: null,
            // 拖拽相关状态
            isResizing: false,
            startX: 0,
            startWidth: 0,
        }
    },
    computed: {
        ...mapGetters(['trackId']),

        tracks() {
            return this.$store.state.common.queue || []
        },
        isPlaying() {
            return this.$store.state.common.isPlaying
        },
        queueIndex() {
            return this.$store.state.common.queueIndex
        },
        songImageWall() {
            const currentTrack = this.tracks[this.queueIndex]
            if (currentTrack && currentTrack.image) {
                return currentTrack.image.replace('al-', 'alw-')
            }
            return null
        },
        backgroundImage() {
            const currentTrack = this.tracks[this.queueIndex]
            return `url('${currentTrack?.image || '/static/dist/img/album_null.jpg'}')`
        },
        remainingTime() {
            const currentTrack = this.tracks[this.queueIndex]
            if (!currentTrack) return 0
            return currentTrack.duration - this.currentTime
        },
        isDlnaMode() {
            return this.$store.getters.isDlnaMode
        },
        isDlnaConnected() {
            return this.$store.getters.isDlnaConnected
        },
        currentDlnaDevice() {
            return this.$store.getters.currentDlnaDevice
        },
        availableDlnaDevices() {
            return this.$store.getters.availableDlnaDevices
        },
        currentTime: {
            get() {
                return this.$store.state.common.currentTime
            },
            set(value) {
                this.$store.state.common.currentTime = value
            }
        },
    },
    created() {
        // 初始化播放器状态
        // this.$store.dispatch('initializePlayer')
        if (this.isDlnaMode) {
            this.startTimer()
        }
        
        if (this.tracks.length !== 0 && this.queueIndex !== -1) {
            this.$api.subsonic.getLyrics(this.tracks[this.queueIndex].id).then((res) => {
                this.lyricsObjArr = this.formatLyrics(res.value)
            })
        }
    },
    mounted() {
        // 添加拖拽事件监听器
        document.addEventListener('mousemove', this.handleLyricResize)
        document.addEventListener('mouseup', this.stopLyricResize)
        
        // 添加窗口大小变化监听器
        window.addEventListener('resize', this.handleWindowResize)
        
        // 初始化歌词区域宽度
        this.$nextTick(() => {
            if (this.$refs['lyric-section']) {
                this.$refs['lyric-section'].style.width = '384px' // 对应原来的 w-96
            }
        })
    },
    beforeDestroy() {
        this.stopTimer()
        // 移除事件监听器
        document.removeEventListener('mousemove', this.handleLyricResize)
        document.removeEventListener('mouseup', this.stopLyricResize)
        window.removeEventListener('resize', this.handleWindowResize)
    },
    watch: {
        '$store.state.common.currentTime': {
            handler(newTime) {
                this.currentTime = newTime
                for (let i = 0; i < this.lyricsObjArr.length; i++) {
                    if (this.currentTime > (parseInt(this.lyricsObjArr[i].time))) {
                        const index = this.$refs.lyric?.[i]?.dataset?.index
                        if (i === parseInt(index)) {
                            this.lyricIndex = i
                            if (this.$refs.lyricUL) {
                                this.$refs.lyricUL.style.transform = `translateY(${170 - (30 * (i + 1))}px)`
                            }
                        }
                    }
                }
            }
        },
        trackId() {
            if (this.trackId === null || this.trackId === -1) {
                return
            }
            if (this.$route.params.id !== this.trackId) {
                this.$api.subsonic.getSong(this.trackId).then((res) => {
                    this.song = res
                })
                this.$api.subsonic.getLyrics(this.trackId).then((res) => {
                    this.lyricsObjArr = this.formatLyrics(res.value)
                })
            }
        }
    },
    methods: {
        startTimer() {
            if (this.timer) {
                clearInterval(this.timer)
            }
            this.timer = setInterval(() => {
                if (this.isDlnaMode && this.isPlaying) {
                    this.currentTime += 1
                    console.log('currentTime', this.currentTime)
                    console.log('duration', this.$store.state.common.duration)
                    if (this.currentTime >= this.$store.state.common.duration) {
                        this.$store.dispatch('next')
                    }
                }
            }, 1000)
        },
        stopTimer() {
            if (this.timer) {
                clearInterval(this.timer)
                this.timer = null
            }
        },
        async playTrack(index) {
            if (index === this.queueIndex && this.isPlaying) {
                await this.$store.dispatch('playPause')
            } else {
                await this.$store.dispatch('playTrackList', { 
                    tracks: this.tracks, 
                    index 
                })
            }
        },
        async playPause() {
            await this.$store.dispatch('playPause')
        },
        async next() {
            await this.$store.dispatch('next')
        },
        async previous() {
            await this.$store.dispatch('previous')
        },
        clear() {
            this.$store.commit('clearQueue')
        },
        shuffle() {
            this.$store.commit('shuffleQueue')
        },
        async playNow(id) {
            const playlist = await this.$api.subsonic.getPlaylist(id)
            return this.$store.dispatch('playTrackList', {
                tracks: playlist.tracks
            })
        },
        async onDeviceSelected(device) {
            try {
                if (device) {
                    await this.$store.dispatch('connectToDlnaDevice', device)
                    this.$myMsg.notify({
                        title: '已切换到DLNA播放',
                        content: `已连接到 ${device.device_info.name}`,
                        type: 'success',
                        time: 1000,
                    })
                } else {
                    await this.$store.dispatch('switchToLocalPlay')
                    this.$myMsg.notify({
                        title: '已切换到本地播放',
                        type: 'info',
                        time: 1000,
                    })
                }
            } catch (error) {
                console.error('切换DLNA设备失败:', error)
                this.$myMsg.notify({
                    title: '设备切换失败',
                    content: error.message || '未知错误',
                    type: 'error',
                    time: 3000,
                })
            }
        },
        formatDuration(value) {
            if (!isFinite(value)) {
                return '∞'
            }
            const minutes = Math.floor(value / 60)
            const seconds = Math.floor(value % 60)
            return (minutes < 10 ? '0' : '') + minutes + ':' + (seconds < 10 ? '0' : '') + seconds
        },
        formatSize(value) {
            return (value / 1024 / 1024).toFixed(1) + ' MB'
        },
        formatLyrics(lyrics) {
            if (!lyrics) return []
            const regNewLine = /\n/
            const lineArr = lyrics.split(regNewLine) // 每行歌词的数组

            const lyricsObjArr = []
            lineArr.forEach(item => {
                if (item === '') return
                const spiltList = item.split(']')
                const spiltListLength = spiltList.length
                const content = spiltList[spiltListLength - 1].trim()

                const timeArray = spiltList.slice(0, spiltListLength - 1)
                timeArray.forEach(dt => {
                    const obj = {}
                    obj.lyric = content === '' ? '' : content
                    obj.time = this.formatLyricTime(dt.slice(1))
                    obj.uid = Math.random().toString().slice(-6)
                    if (obj.lyric === '') {
                        console.log('')
                    } else {
                        lyricsObjArr.push(obj)
                    }
                })
            })
            return lyricsObjArr.sort((a, b) => a.time - b.time)
        },
        formatLyricTime(item) { // 格式化歌词的时间 转换成 sss:ms
            if (item.indexOf('.') === -1) {
                const timeParts = item.split(':')
                const hours = parseInt(timeParts[0])
                const minutes = parseInt(timeParts[1])
                const seconds = parseInt(timeParts[2])
                const totalTime = hours * 60 * 60 + minutes * 60 + seconds
                return Number(totalTime)
            } else {
                const regTime = /\d{2}:\d{2}.\d{2,3}/
                const isTime = item.match(regTime)
                const time = isTime ? isTime[0] : '00:00.00'
                const regMin = /.*:/
                const regSec = /:.*\./
                const regMs = /\./

                const min = parseInt(time.match(regMin)[0].slice(0, 2))
                let sec = parseInt(time.match(regSec)[0].slice(1, 3))
                const ms = time.slice(time.match(regMs).index + 1, time.match(regMs).index + 3)
                if (min !== 0) {
                    sec += min * 60
                }
                return Number(sec + '.' + ms)
            }
        },
        scrollToLyric(i) {
            const currentTime = this.lyricsObjArr[i].time
            const seek = currentTime / this.$store.state.common.duration
            this.$store.dispatch('seek', seek)
        },
        dragStart(event, index) {
            this.draggedIndex = index;
            event.dataTransfer.effectAllowed = 'move';
            event.target.style.opacity = '0.4';
        },
        dragEnd(event) {
            const rows = event.target.parentElement.getElementsByTagName('tr');
            for (let row of rows) {
                row.style.opacity = '1';
            }
        },
        drop(event, index) {
            event.preventDefault();
            console.log('拖拽重排序功能待实现')
        },
        
        // 初始化DLNA功能
        async initializeDlna() {
            try {
                console.log('初始化DLNA功能...')
                // 发现DLNA设备
                await this.$store.dispatch('discoverDlnaDevices')
                console.log('DLNA设备发现完成, 设备数量:', this.availableDlnaDevices.length)
            } catch (error) {
                console.warn('初始化DLNA功能失败:', error)
            }
        },

        // 测试DLNA功能
        testDlnaFeatures() {
            console.log('=== DLNA功能测试 ===')
            console.log('当前播放模式:', this.$store.state.common.playMode)
            console.log('是否DLNA模式:', this.isDlnaMode)
            console.log('是否DLNA连接:', this.isDlnaConnected)
            console.log('当前DLNA设备:', this.currentDlnaDevice)
            console.log('可用DLNA设备:', this.availableDlnaDevices)
            console.log('AudioController实例:', window.audioController)
            console.log('================')
        },

        // 歌词区域拖拽相关方法
        startLyricResize(e) {
            this.isResizing = true
            this.startX = e.clientX
            this.startWidth = this.$refs['lyric-section'].offsetWidth
        },
        handleLyricResize(e) {
            if (!this.isResizing) return
            
            const width = this.startWidth + (e.clientX - this.startX)
            const minLyricWidth = 300 // 歌词区域最小宽度
            const minPlayingWidth = 400 // 正在播放区域最小宽度
            const resizeHandleWidth = 4 // 拖拽手柄宽度
            const containerPadding = 24 // 容器边距
            
            // 计算最大允许宽度：总宽度 - 正在播放最小宽度 - 拖拽手柄宽度 - 边距
            const maxLyricWidth = window.innerWidth - minPlayingWidth - resizeHandleWidth - containerPadding
            
            // 确保宽度在合理范围内
            const finalWidth = Math.max(minLyricWidth, Math.min(width, maxLyricWidth))
            
            if (this.$refs['lyric-section']) {
                this.$refs['lyric-section'].style.width = `${finalWidth}px`
            }
        },
        stopLyricResize() {
            this.isResizing = false
        },
        handleWindowResize() {
            // 窗口大小变化时检查歌词区域宽度是否超出限制
            if (this.$refs['lyric-section']) {
                const currentWidth = this.$refs['lyric-section'].offsetWidth
                const minLyricWidth = 300
                const minPlayingWidth = 400
                const resizeHandleWidth = 4
                const containerPadding = 24
                
                const maxLyricWidth = window.innerWidth - minPlayingWidth - resizeHandleWidth - containerPadding
                
                if (currentWidth > maxLyricWidth) {
                    this.$refs['lyric-section'].style.width = `${maxLyricWidth}px`
                }
            }
        },
    }
}
</script>
<style>
.h-screen-lyric {
    height: calc(100vh - 230px);
}

/* 歌词区域样式 */
.lyric-section {
    width: 384px; /* 默认宽度，对应 w-96 */
    min-width: 300px;
    flex-shrink: 0; /* 防止被挤压 */
}

/* 拖拽手柄样式 */
.resize-handle {
    width: 4px;
    background-color: transparent;
    cursor: col-resize;
    transition: background-color 0.2s;
    position: relative;
    flex-shrink: 0;
}

.resize-handle::after {
    content: '';
    position: absolute;
    top: 0;
    left: -3px;
    width: 10px;
    height: 100%;
    background-color: transparent;
}

.resize-handle:hover {
    background-color: rgba(0, 0, 0, 0.1);
}

/* 确保拖动时拖动条保持显示 */
.resize-handle.resizing,
.resize-handle:hover {
    background-color: rgba(0, 0, 0, 0.1);
}

/* 暗色模式下的拖拽手柄样式 */
[data-theme="dark"] .resize-handle:hover,
[data-theme="dark"] .resize-handle.resizing {
    background-color: rgba(255, 255, 255, 0.2);
}

@media (min-width: 1280px) {
    .xl\:w-screen-sidebar {
        width: calc(100vw - 240px);
    }
}
</style>
